import { useState, useRef, useEffect, useCallback } from 'react';
import { 
  Tabs,
  DatePicker,
  Button,
  Select,
  Form, 
  Input,
  InputNumber,
  Slider,
  Col, 
  Row 
} from 'antd';
import { connect } from 'react-redux'
import * as act from "../../Store/actions"
import * as com from "../../Common"
import {
  calcMonthsFromPurchaseDate,
  calcDefaultRate,
  calculateLTAIVPercentage,
  calculateLTCPercentage,
  calculateLTARVPercentage,
  calculateTotalCost,
  calculateInterestReservesAmount
} from "./Utils"
import {
  QuestionCircleFilled
} from '@ant-design/icons';
import "./LoanRateCalculator.css";

const mapStateToProps = (state) => {
  return {
      application: state.application,
      progress: state.progress,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateHardMoneyLoanAttribute: (t, verb) => {
    dispatch(act.UpdateHardMoneyLoanAttribute(t, verb));
  },
  changeMainPropertyAttribute: (t, verb) => {
    dispatch(act.ChangeMainPropertyAttribute(t, verb));
  },
  changeMainPropertyPurpose: (val) => {
    dispatch(act.ChangeMainPropertyPurpose(val));
  },
  updateProduct: (v, verb) => {
    dispatch(act.UpdateProduct(v, verb))
},
});

export default function LoanRateCalculator(props) {
  const [active, setActive] = useState('1')
  const [loanType, setLoanType] = useState('1')
  const [bridgeType, setBridgeType] = useState('5')
  const [rehabLoan, setRehabLoan] = useState(false)
  const [rehabType, setRehabType] = useState('1')
  const [existingLoan, setExistingLoan] = useState('2')
  const [propertyCounty, setPropertyCounty] = useState('')
  const [showTotalCost, setShowTotalCost] = useState(false)
  const [showTotalLoanAmount, setShowTotalLoanAmount] = useState(false)
  const [showRatios, setShowRatios] = useState(false)
  const [currentLTAIV, setCurrentLTAIV] = useState(0)
  const [currentLTC, setCurrentLTC] = useState(0)
  const [currentLTARV, setCurrentLTARV] = useState(0)
  const [showExpAlert, setShowExpAlert] = useState(false)
  const [showPermitAlert, setShowPermitAlert] = useState(false)
  const [form] = Form.useForm();
  const autoCompleteRef = useRef();
  const inputRef = useRef();
  useEffect(()=>{
    props.updateProduct("hardmoneyloan", "mortgageapplied");
    props.changeMainPropertyPurpose("purchaserehab")
    props.updateHardMoneyLoanAttribute(780, "estimatedfico")
    props.updateHardMoneyLoanAttribute(12, "mortgagetermmonths")
    props.changeMainPropertyAttribute("1000000", "salesprice")
    props.changeMainPropertyAttribute("1000000", "appraisal")
    props.updateHardMoneyLoanAttribute("700000", "initialloanamount")
  }, [])
  useEffect(() => {
    if (active === '2') {
      setLoanType(bridgeType)
    } else {
      if (active === '1') {
        setRehabLoan(true)
      }
      setLoanType(active)
    }
  }, [bridgeType, active])

  useEffect(() => {
    if (showTotalCost) {
      if (active === "1") {
        if (form.getFieldValue("existLoan") === "1") {
          form.setFieldsValue({
            totalCost: calculateTotalCost(
              com.safeParseInt(form.getFieldValue("appraisedValue")),
              form.getFieldValue("rehabBudget"), 
              form.getFieldValue("interestReserves")
            )
          })
        } else {
          if (calcMonthsFromPurchaseDate(form.getFieldValue("purchaseDate")) > 6) {
            form.setFieldsValue({
              totalCost: calculateTotalCost(
                form.getFieldValue("appraisedValue"), 
                form.getFieldValue("rehabBudget"), 
                form.getFieldValue("interestReserves")
              )
            })
          } else {
            form.setFieldsValue({
              totalCost: calculateTotalCost(
                com.safeParseInt(form.getFieldValue("purchasePrice")) + com.safeParseInt(form.getFieldValue("costToDate")), 
                form.getFieldValue("rehabBudget"), 
                form.getFieldValue("interestReserves")
              )
            })
          }
        }
      }
      if (active === "3") {
        let borrowerExperience = form.getFieldValue("purchased") + form.getFieldValue("flipped")
        let interestReservesAmount = calculateInterestReservesAmount(
              form.getFieldValue("interestReserves"), 
              com.safeParseInt(form.getFieldValue("initialLoanAmount")) + com.safeParseInt(form.getFieldValue("constructionBudget")), 
              form.getFieldValue("loanTerm"), 
              borrowerExperience
            )
        if (form.getFieldValue("existLoan") === "1") {
          form.setFieldsValue({
            totalCost: calculateTotalCost(
              com.safeParseInt(form.getFieldValue("appraisedValue")),
              form.getFieldValue("constructionBudget"), 
              interestReservesAmount
            )
          })
        } else {
          if (calcMonthsFromPurchaseDate(form.getFieldValue("purchaseDate")) > 6) {
            form.setFieldsValue({
              totalCost: calculateTotalCost(
                form.getFieldValue("appraisedValue"), 
                form.getFieldValue("constructionBudget"), 
                interestReservesAmount
              )
            })
          } else {
            form.setFieldsValue({
              totalCost: calculateTotalCost(
                com.safeParseInt(form.getFieldValue("purchasePrice")) + com.safeParseInt(form.getFieldValue("costToDate")), 
                form.getFieldValue("constructionBudget"), 
                interestReservesAmount
              )
            })
          }
        }
      }
    } else {
      form.setFieldsValue({
        totalCost: ""
      })
    }
  },[
    showTotalCost, 
    form.getFieldValue("purchased"), 
    form.getFieldValue("flipped"), 
    form.getFieldValue("loanTerm"), 
    form.getFieldValue("interestReserves"), 
    form.getFieldValue("totalLoanAmount"),
    form.getFieldValue("appraisedValue"),
    form.getFieldValue("constructionBudget"),
    form.getFieldValue("purchasePrice"),
    form.getFieldValue("rehabBudget"),
    form.getFieldValue("purchaseDate"),
    form.getFieldValue("cashoutAmount"),
    form.getFieldValue("costToDate"),
    existingLoan,
    active,

  ])

  useEffect(() => {
    if (active !== "2") {
      if (showTotalLoanAmount) {
        form.setFieldsValue({
          totalLoanAmount: 
            com.safeParseInt(form.getFieldValue("initialLoanAmount")) + 
            com.safeParseInt(form.getFieldValue("rehabLoanAmount")) +
            com.safeParseInt(form.getFieldValue("constructionBudget")) +
            com.safeParseInt(form.getFieldValue("cashoutAmount")) +
            // com.safeParseInt(form.getFieldValue("existingLoanAmount")) +
            // com.safeParseInt(form.getFieldValue("totalLoanAmount")) +
            calculateInterestReservesAmount(
              form.getFieldValue("interestReserves"),
              com.safeParseInt(form.getFieldValue("initialLoanAmount")) + com.safeParseInt(form.getFieldValue("constructionBudget")),
              form.getFieldValue("loanTerm"),
              form.getFieldValue("purchased") + form.getFieldValue("flipped")
            )
        })
      } else {
        form.setFieldsValue({
          totalLoanAmount: ""
        })
      }
    }
  },[
    showTotalLoanAmount,
    form.getFieldValue("initialLoanAmount"),
    form.getFieldValue("rehabLoanAmount"),
    form.getFieldValue("constructionBudget"),
    form.getFieldValue("cashoutAmount"),
    form.getFieldValue("existingLoanAmount"),
    form.getFieldValue("interestReserves"),
    form.getFieldValue("loanTerm"),
    form.getFieldValue("purchased"),
    form.getFieldValue("flipped"),
    active
  ])

  useEffect(() => {
    let lesserPrice = com.safeParseInt(form.getFieldValue("purchasePrice")) < com.safeParseInt(form.getFieldValue("appraisedValue")) ? com.safeParseInt(form.getFieldValue("purchasePrice")) : com.safeParseInt(form.getFieldValue("appraisedValue"))
    if (active === "1") {
      if (form.getFieldValue("existLoan") === "1") {
        setCurrentLTAIV(
          calculateLTAIVPercentage(
            form.getFieldValue("appraisedValue"), 
            form.getFieldValue("initialLoanAmount")
          )
        )
      } else {
        setCurrentLTAIV(
          calculateLTAIVPercentage(
            lesserPrice,
            form.getFieldValue("initialLoanAmount")
          )
        )
      }
    } else if (active === "3") {
      setCurrentLTAIV(
        calculateLTAIVPercentage(
          form.getFieldValue("appraisedValue"),
          form.getFieldValue("initialLoanAmount")
        )
      )
    } else {
      if (bridgeType === "4") {
        setCurrentLTAIV(
          calculateLTAIVPercentage(
            form.getFieldValue("appraisedValue"),
            com.safeParseInt(form.getFieldValue("existingLoanAmount")) + com.safeParseInt(form.getFieldValue("cashoutAmount"))
          )
        )
      } else if (bridgeType === "5") {
        setCurrentLTAIV(
          calculateLTAIVPercentage(
            lesserPrice,
            form.getFieldValue("totalLoanAmount")
          )
        )
      } else {
        setCurrentLTAIV(
          calculateLTAIVPercentage(
            form.getFieldValue("appraisedValue"),
            form.getFieldValue("totalLoanAmount")
          )
        )
      }
    }
  }, [
    form.getFieldValue("appraisedValue"),
    form.getFieldValue("purchasePrice"),
    form.getFieldValue("initialLoanAmount"),
    form.getFieldValue("existingLoanAmount"),
    form.getFieldValue("totalLoanAmount"),
    form.getFieldValue("cashoutAmount"),
    active,
    bridgeType
  ])

  useEffect(() => {
    let lesserPrice = com.safeParseInt(form.getFieldValue("purchasePrice")) < com.safeParseInt(form.getFieldValue("appraisedValue")) ? com.safeParseInt(form.getFieldValue("purchasePrice")) : com.safeParseInt(form.getFieldValue("appraisedValue"))
    if (active !== "2") {
        setCurrentLTC(
          calculateLTCPercentage(
            form.getFieldValue("totalCost"),
          form.getFieldValue("totalLoanAmount")
        )
      )
    } else {
      if (bridgeType === "4") {
        setCurrentLTC(
          calculateLTCPercentage(
            form.getFieldValue("appraisedValue"),
            com.safeParseInt(form.getFieldValue("existingLoanAmount")) + com.safeParseInt(form.getFieldValue("cashoutAmount"))
          )
        )
      } else if (bridgeType === "5") {
        setCurrentLTC(
          calculateLTCPercentage(
            lesserPrice,
            form.getFieldValue("totalLoanAmount")
          )
        )
      } else {
        setCurrentLTC(
          calculateLTCPercentage(
            form.getFieldValue("appraisedValue"),
            form.getFieldValue("totalLoanAmount")
          )
        )
      }
    }
  }, [
    form.getFieldValue("totalCost"), 
    form.getFieldValue("totalLoanAmount"),
    form.getFieldValue("appraisedValue"),
    form.getFieldValue("purchasePrice"),
    form.getFieldValue("existingLoanAmount"),
    form.getFieldValue("cashoutAmount"),
    active,
    bridgeType,
    existingLoan
  ])

  useEffect(() => {
    let lesserPrice = com.safeParseInt(form.getFieldValue("purchasePrice")) < com.safeParseInt(form.getFieldValue("appraisedValue")) ? com.safeParseInt(form.getFieldValue("purchasePrice")) : com.safeParseInt(form.getFieldValue("appraisedValue"))
    if (active !== "2") {
      setCurrentLTARV(
        calculateLTARVPercentage(
          form.getFieldValue("projectedAfterRepair"),
          form.getFieldValue("totalLoanAmount")
        )
      )
    } else {
      if (bridgeType === "4") {
        setCurrentLTARV(
          calculateLTARVPercentage(
            form.getFieldValue("appraisedValue"),
            com.safeParseInt(form.getFieldValue("existingLoanAmount")) + com.safeParseInt(form.getFieldValue("cashoutAmount"))
          )
        )
      } else if (bridgeType === "5") {
        setCurrentLTARV(
          calculateLTARVPercentage(
            lesserPrice,
            form.getFieldValue("totalLoanAmount")
          )
        )
      } else {
        setCurrentLTARV(
          calculateLTARVPercentage(
            form.getFieldValue("appraisedValue"),
            form.getFieldValue("totalLoanAmount")
          )
        )
      }
    }
  }, [
    form.getFieldValue("projectedAfterRepair"), 
    form.getFieldValue("totalLoanAmount"),
    form.getFieldValue("appraisedValue"),
    form.getFieldValue("purchasePrice"),
    form.getFieldValue("existingLoanAmount"),
    form.getFieldValue("cashoutAmount"),
    active,
    bridgeType
  ])

  useEffect(() => {
    if (form.getFieldValue("rehabType") === "2" && form.getFieldValue("flipped") + form.getFieldValue("purchased") < 3) {
      setShowExpAlert(true)
    } else {
      setShowExpAlert(false)
    }
  },[
    form.getFieldValue("flipped"),
    form.getFieldValue("purchased"),
    form.getFieldValue("rehabType"),
    form.getFieldValue("appraisedValue")
  ])

  const hideRatiosOnFocus = () => {
    setShowRatios(false)
  }

  const showRatiosOnBlur = () => {
    if (active !== "2"){
      if (
        form.getFieldValue("initialLoanAmount") !== "" &&
        (form.getFieldValue("rehabLoanAmount") !== "" || form.getFieldValue("constructionBudget") !== "") &&
        form.getFieldValue("appraisedValue") !== "" &&
        form.getFieldValue("projectedAfterRepair") !== "" 
      ) {
        setShowRatios(true)
      } else {
        setShowRatios(false)
      }
    } else {
      if (
        (form.getFieldValue("totalLoanAmount") !== "" || form.getFieldValue("existingLoanAmount") !== "" || form.getFieldValue("cashoutAmount") !== "") &&
        form.getFieldValue("appraisedValue") !== "" 
      ) {
        setShowRatios(true)
      } else {
        setShowRatios(false)
      }
    }
  }

  useEffect(() => {
    // 1. Preserve current address values
    const currentAddressValues = form.getFieldsValue(['address', 'city', 'state', 'zipCode']);

    const currentLoanValues = form.getFieldsValue(['appraisedValue', 'projectedAfterRepair', 'purchasePrice', 'flipped', 'purchased', 'closingDate', 'purchaseDate', 'costToDate', 'existingLoanAmount']);
    // 2. Reset all other fields to initial values
    form.resetFields();

    // 3. Restore address fields if they had values
    const restoreValues = {};
    if (currentAddressValues.address) restoreValues.address = currentAddressValues.address;
    if (currentAddressValues.city) restoreValues.city = currentAddressValues.city;
    if (currentAddressValues.state) restoreValues.state = currentAddressValues.state;
    if (currentAddressValues.zipCode) restoreValues.zipCode = currentAddressValues.zipCode;

    const restoreLoanValues = {};
    if (currentLoanValues.appraisedValue) restoreLoanValues.appraisedValue = currentLoanValues.appraisedValue;
    if (currentLoanValues.projectedAfterRepair) restoreLoanValues.projectedAfterRepair = currentLoanValues.projectedAfterRepair;
    if (currentLoanValues.purchasePrice) restoreLoanValues.purchasePrice = currentLoanValues.purchasePrice;
    if (currentLoanValues.flipped) restoreLoanValues.flipped = currentLoanValues.flipped;
    if (currentLoanValues.purchased) restoreLoanValues.purchased = currentLoanValues.purchased;
    if (currentLoanValues.closingDate) restoreLoanValues.closingDate = currentLoanValues.closingDate;
    if (currentLoanValues.purchaseDate) restoreLoanValues.purchaseDate = currentLoanValues.purchaseDate;
    if (currentLoanValues.costToDate) restoreLoanValues.costToDate = currentLoanValues.costToDate;
    if (currentLoanValues.existingLoanAmount) restoreLoanValues.existingLoanAmount = currentLoanValues.existingLoanAmount;
    if (Object.keys(restoreValues).length > 0) {
        form.setFieldsValue(restoreValues);
    }

    if (Object.keys(restoreLoanValues).length > 0) {
        form.setFieldsValue(restoreLoanValues);
    }

    // 4. Reset local state related to form sections
    setShowTotalCost(false);
    setShowTotalLoanAmount(false);
    setShowRatios(false);
    setCurrentLTAIV(0);
    setCurrentLTC(0);
    setCurrentLTARV(0);
    // Reset state controlling conditional inputs/defaults based on active tab
    setBridgeType('5'); // Default for Bridge tab
    setRehabType('1');  // Default for Rehab tab
    setExistingLoan('2'); // Default for GUC tab
    setShowExpAlert(false)
    setShowPermitAlert(false)
    props.setMonthFromPurchase(0);

  }, [active, form]);

  const tabsOnChange = (key) => {
    setActive(key);
    form.setFieldsValue({
      propertyType: 'singlefamilydetached',
    })
  };
  const handleloanTerm = (value) => {
    console.log(`selected ${value}`);
  };
  const rehabLoanOnChange = (e) => {
    setRehabLoan(e.target.checked);
  };
  const inputFormatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  const inputParser = (value) => {
    return value.replace(/\\s?|(,*)/g, '')
  }
  const onFinish = (values) => {
    let r = {...props.application.hardmoneyloan.refinancedetails}
    props.setOnLanding(false)
    props.changeMainPropertyAttribute(values.propertyType, "propertytype")
    props.changeMainPropertyAttribute(values.purchasePrice, "salesprice")
    props.changeMainPropertyAttribute(values.address, "address")
    props.changeMainPropertyAttribute(values.state, "state")
    props.changeMainPropertyAttribute(values.city, "city")
    props.changeMainPropertyAttribute(propertyCounty, "county")
    props.changeMainPropertyAttribute(values.zipCode, "zipcode")
    props.updateHardMoneyLoanAttribute(String(values.closingDate), "targetclosingdate")
    
    props.updateHardMoneyLoanAttribute(com.safeParseInt(values.loanTerm), "mortgagetermmonths")
    props.updateHardMoneyLoanAttribute(rehabLoan, "rehabloan")
    props.updateHardMoneyLoanAttribute(rehabLoan?String(values.rehabLoanAmount): "", "rehabloanamount")
    props.updateHardMoneyLoanAttribute(active === "3"?String(values.projectedAfterRepair) : rehabLoan?String(values.projectedAfterRepair):"", "projectedafterrepairvalue")
    props.updateHardMoneyLoanAttribute(values.flipped, "timesofflippingaproperty")
    props.updateHardMoneyLoanAttribute(values.purchased, "timesofpurchasingarentalproperty")
    props.updateHardMoneyLoanAttribute(values.FICO, "estimatedfico")
    switch (loanType) {
      case "1":
        props.changeMainPropertyPurpose("purchaserehab")
        props.changeMainPropertyAttribute(values.purchasePrice, "salesprice")
        props.changeMainPropertyAttribute(values.appraisedValue, "appraisal")
        props.updateHardMoneyLoanAttribute(String(values.purchasePrice), "initialadvancerequested")
        props.updateHardMoneyLoanAttribute(String(com.safeParseInt(values.initialLoanAmount)), "initialloanamount")
        props.updateHardMoneyLoanAttribute(String(com.safeParseInt(values.rehabLoanAmount)), "rehabloanamount")
        // props.updateHardMoneyLoanAttribute(rehabBudget, "rehabbudget")
        props.setRehabBudget(values.rehabBudget)
        break;
      case "2":
        props.changeMainPropertyPurpose("refinance")


        props.setCostToDate(values.costToDate)
        props.setMonthFromPurchase(calcMonthsFromPurchaseDate(values.purchaseDate))
        r["estimatedCurrentValue"] = String(values.appraisedValue)
        r["existingLoanAmount"] = String(values.existingLoanAmount)
        props.updateHardMoneyLoanAttribute(r, "refinancedetails")
        props.changeMainPropertyAttribute(values.appraisedValue, "appraisal")
        props.updateHardMoneyLoanAttribute(String(values.totalLoanAmount), "initialloanamount")
        props.updateHardMoneyLoanAttribute(String(values.totalLoanAmount), "refinanceloanamount")
        break;
      case "3":
        props.changeMainPropertyPurpose("construction")

        props.setCostToDate(values.costToDate)
        props.setMonthFromPurchase(calcMonthsFromPurchaseDate(values.purchaseDate))
        props.changeMainPropertyAttribute(values.appraisedValue, "appraisal")
        props.changeMainPropertyAttribute(values.purchasePrice, "salesprice")
        props.updateHardMoneyLoanAttribute("groundup", "loantype")
        props.updateHardMoneyLoanAttribute(String(values.initialLoanAmount), "initialloanamount")
        props.updateHardMoneyLoanAttribute(String(values.constructionBudget), "constructionloanamount")
        props.updateHardMoneyLoanAttribute(String(values.constructionBudget), "constructionbudget")

        if (values.existLoan === "1") {
          r["existingLoanAmount"] = String(values.existingLoanAmount)
          props.updateHardMoneyLoanAttribute(r, "refinancedetails")
        } else {
          r["existingLoanAmount"] = "0"
          props.updateHardMoneyLoanAttribute(r, "refinancedetails")
        }
        props.setInterestReserves(values.interestReserves)
        props.setLandEntitlement(values.landEntitlement)

        break;
      case "4":
        props.changeMainPropertyPurpose("cashoutrefinance")

        props.setCostToDate(values.costToDate)
        props.setMonthFromPurchase(calcMonthsFromPurchaseDate(values.purchaseDate))
        props.changeMainPropertyAttribute(values.appraisedValue, "appraisal")
        r["estimatedCurrentValue"] = String(values.purchasePrice)
        r["existingLoanAmount"] = String(values.existingLoanAmount)
        props.updateHardMoneyLoanAttribute(r, "refinancedetails")
        props.updateHardMoneyLoanAttribute(String(values.existingLoanAmount + values.cashoutAmount), "initialloanamount")
        props.updateHardMoneyLoanAttribute(String(values.existingLoanAmount + values.cashoutAmount), "refinanceloanamount")
        props.setCashoutAmount(values.cashoutAmount)
        break;
      case "5":
        props.changeMainPropertyPurpose("purchase")
        props.changeMainPropertyAttribute(values.appraisedValue, "appraisal")
        props.changeMainPropertyAttribute(values.purchasePrice, "salesprice")
        props.updateHardMoneyLoanAttribute(String(values.totalLoanAmount), "initialloanamount")
        break;
      default:
        break;
    }
    props.setShowResult(true)
  }
  const formInitial = {
    propertyType: 'singlefamilydetached',
    constructionType: 'singlefamilydetached',
    purchasePrice: '',
    appraisedValue: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    closingDate: '',
    existingLoanAmount: '',
    loanAmount: '',
    loanTerm: '12',
    rehabLoanAmount: '',
    constructionBudget: '',
    constructionLoanAmount: '',
    projectedAfterRepair: '',
    flipped: 0,
    purchased: 0,
    FICO: 780,
    bridgeType: '5',
    existLoan: '2',
    rehabType: '1',
    rehabBudget: '',
    cashoutAmount: '',
    interestReserves: '',
    initialLoanAmount: '',
    totalLoanAmount: '',
    landEntitlement: 'permitready',
    totalCost: '',
    purchaseDate: '',
    costToDate: ''
  }
  const items = [
    // {
    //   key: '1',
    //   label: `Purchase`
    // },
    // {
    //   key: '2',
    //   label: `Rate term refi`
    // },
    // {
    //   key: '4',
    //   label: 'Cash out refi'
    // },
    // {
    //   key: '3',
    //   label: `Construction`
    // },
    {
      key: '1',
      label: `Rehab`
    },
    {
      key: '2',
      label: `Bridge`
    },
    {
      key: '3',
      label: `GUC`
    },
  ];
  const BridgeTypeOptions = [
    {
      value: '5',
      label: `Purchase`
    },
    {
      value: '2',
      label: `Refinance`
    },
    {
      value: '4',
      label: `Cashout`
    }
    
  ]
  const RehabTypeOptions = [
    {
      value: '1',
      label: `Light rehab`
    },
    {
      value: '2',
      label: `Heavy rehab`
    }
  ]
  const existingLoanOptions = [
    {
      value: '1',
      label: `Yes`
    },
    {
      value: '2',
      label: `No`
    }
  ]
  const PropertyTypeOptions = [
    {
      value: 'singlefamilydetached',
      label: 'Single family residence'
    },
    {
      value: 'twotofourfamily',
      label: '2-4 unit family'
    },
    // {
    //   value: 'mixeduse',
    //   label: 'Mixed Use(50%+ residential)'
    // },
    {
      value: 'multistory',
      label: 'Multi family (4+ units)',
    },
  ]
  const BridgePropertyTypeOptions = [
    {
      value: 'singlefamilydetached',
      label: 'Single family residence'
    },
    {
      value: 'twotofourfamily',
      label: '2-4 unit family'
    },
    {
      value: 'multistory',
      label: 'Multi family (4+ units)',
    },
    {
      value: 'land',
      label: 'Raw land'
    }
  ]
  const LandEntitlementOptions = [
    {
      value: 'permitready',
      label: `Yes`
    },
    {
      value: 'permitnotready',
      label: `No`
    }
  ]
  const constructionType = [
    {
      value: 'singlefamilydetached',
      label: 'Single family residence'
    }
  ]
  const loanTermOptions = [
    // {
    //   value: '3',
    //   label: '3 Months'
    // },
    // {
    //   value: '6',
    //   label: '6 Months'
    // },
    // {
    //   value: '9',
    //   label: '9 Months'
    // },
    {
      value: '12',
      label: '12 Months'
    },
    {
      value: '18',
      label: '18 Months'
    },
    {
      value: '24',
      label: '24 Months'
    },
  ]
  const googleOptions = {
    componentRestrictions: { country: "us"},
    fields: ["address_components", "formatted_address"]
 };
  useEffect(() => {
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current,
      googleOptions
    );
    autoCompleteRef.current.addListener("place_changed", async function () {
      const place = await autoCompleteRef.current.getPlace();
      const address = `${place.address_components.find(item =>item.types.includes("street_number")).short_name} ${place.address_components.find(item =>item.types.includes("route")).short_name}, ${place.address_components.find(item =>item.types.includes("country")).short_name}`
      const county = place.address_components.find(item => item.types.includes("administrative_area_level_2")).long_name
      setPropertyCounty(county)
      form.setFieldsValue({
        address: address,
        city: place.formatted_address.split(',')[1],
        state: place.address_components.find(item =>item.types.includes("administrative_area_level_1")).short_name,
        zipCode: place.address_components.find(item => item.types.includes("postal_code")).long_name
      });
      console.log("county", county)
    });
  }, [googleOptions,form]);
  return (
    <div className='loan-rate-calculator'>
      <Tabs className='calc-tabs' defaultActiveKey={active} type="card" items={items} onChange={tabsOnChange} />
      <div className='form-wrap'>
        <Form
          layout='vertical'
          form={form}
          initialValues={formInitial}
          onFinish={onFinish}
          size="large"
        >
                    <Row gutter={80}>
            <Col span={24}>
              <div className='check-item'>
                <div><span style={{marginRight: '12px'}}>In the last 3 years, how many times have you...</span></div>
                {/* <Tooltip title="prompt text">
                  <QuestionCircleFilled className="tips-icon" />
                </Tooltip> */}
              </div>
            </Col>
            <Col span={24} md={12}>
              <Form.Item 
                name="flipped" 
                label="flipped a property?"
                onFocus={() => {
                  setShowTotalCost(false)
                  setShowTotalLoanAmount(false)
                  hideRatiosOnFocus()
                }}
                onBlur={() => {
                  setShowTotalCost(true)
                  setShowTotalLoanAmount(true)
                  showRatiosOnBlur()
                }}
                validateTrigger={['onBlur', 'onSubmit']}
                rules={[
                  ({ getFieldValue, setFieldsValue }) => ({
                    validator(_, value) {
                      if (value + com.safeParseInt(getFieldValue("purchased")) < 3) {
                        setShowExpAlert(true)  
                      } else {
                        setShowExpAlert(false)
                      }
                      return Promise.resolve();
                    }
                  })
                ]}
              >
                <InputNumber 
                  style={{ width: '100%' }}
                  min={0}
                  precision={0}
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item 
                name="purchased" 
                label="purchased a rental property?"
                onFocus={() => {
                  setShowTotalCost(false)
                  setShowTotalLoanAmount(false)
                  hideRatiosOnFocus()
                }}
                onBlur={() => {
                  setShowTotalCost(true)
                  setShowTotalLoanAmount(true)
                  showRatiosOnBlur()
                }}
                validateTrigger={['onBlur', 'onSubmit']}
                rules={[
                  ({ getFieldValue, setFieldsValue }) => ({
                    validator(_, value) {
                      if (value + com.safeParseInt(getFieldValue("flipped")) < 3) {
                        setShowExpAlert(true)  
                      } else {
                        setShowExpAlert(false)
                      }
                      return Promise.resolve();
                    }
                  })
                ]}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  min={0}
                  precision={0}
                />
              </Form.Item>
            </Col>
            {showExpAlert && (active === "3" || (active === "1" && rehabType === "2")) && (
              <div className='alert-row'>{`You must have flipped or purchased at least 3 properties in the last 3 years to be eligible for this loan.`}</div>
            )}
          </Row>

          <Row gutter={80} justify="center" style={{padding: '16px 50px 16px 50px'}}>
            <Col span={24} md={12} className='score-item'>
              <span className='label'>Your FICO credit score</span>
              <Form.Item name="FICO">
                <InputNumber
                  className='score-input'
                  style={{ width: '100%' }}
                  min={500}
                  max={1000}
                  precision={0}
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12} className='score-item'>
              <span className='num'>500</span>
              <Form.Item name="FICO">
                <Slider
                  className='score-slider'
                  min={500}
                  max={1000}
                  trackStyle={{backgroundColor: '#0F62FE'}}
                  railStyle={{backgroundColor: '#C1C7CD'}}
                />
              </Form.Item>
              <span className='num'>1000</span>
            </Col>

          </Row>
           <Row gutter={24}>
            <Col span={24}>
              <Form.Item name="address" label="Property Address">
                <input className='addr-input' ref={inputRef} placeholder="Address" />
              </Form.Item>
            </Col>
            <Col span={24} md={8}>
              <Form.Item name="city">
                <Input readOnly placeholder="City" />
              </Form.Item>
            </Col>
            <Col span={24} md={8}>
              <Form.Item name="state">
                <Input readOnly placeholder="State" />
              </Form.Item>
            </Col>
            <Col span={24} md={8}>
              <Form.Item name="zipCode">
                <Input readOnly placeholder="Zip Code" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24} md={12}>
              <Form.Item name="closingDate" label="Target Closing Date">
                <DatePicker 
                    className='closing-date' 
                    placeholder="MM/DD/YYYY" 
                    format="MM/DD/YYYY" 
                />
              </Form.Item>
            </Col>
            <Col span={24} md={12}>
              <Form.Item name="loanTerm" label="Loan Term">
                <Select
                  allowClear
                  onChange={handleloanTerm}
                  options={loanTermOptions}
                />
              </Form.Item>
            </Col>
          </Row>
          { active === '1' && 
            <Row gutter={24} style={{padding: '16px 50px 0 50px'}}>
              <Col span={24} md={12}>
                <Form.Item
                  name="propertyType"
                  label="Property Type"
                  className='tooltip-item'
                >
                <Select
                  allowClear
                  options={PropertyTypeOptions}
                />
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item
                  name="purchasePrice"
                  label="Purchase Price"
                  onBlur={() => {
                    setShowTotalCost(true)
                    showRatiosOnBlur()
                  }}
                  onChange={(value) => {
                    setShowTotalCost(false)
                  }}
                  onFocus={hideRatiosOnFocus}
                >
                  <InputNumber
                    prefix="$" 
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={24} md={12}>
                <Form.Item
                  name="rehabType"
                  label="Rehab Type"
                  className='tooltip-item'
                  // tooltip={{
                  //   title: 'Property Type',
                  //   icon: <QuestionCircleFilled className="tips-icon" />,
                  // }}
                  validateTrigger={['onBlur']}
                  rules={[
                    ({ getFieldValue, setFieldsValue }) => ({
                      validator(_, value) {
                        if (value === '2' && getFieldValue("flipped") + getFieldValue("purchased") < 3) {
                          setShowExpAlert(true)
                        } else {
                          setShowExpAlert(false)
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                <Select
                  allowClear
                  options={RehabTypeOptions}
                  onChange={(value) => {
                    setRehabType(value)
                  }}
                />
                </Form.Item>
              </Col> */}
              <Col span={24} md={existingLoan === '1' ? 12 : 24}>
                  <Form.Item 
                    name="existLoan" 
                    label="Existing Loan"
                    // onFocus={() => {
                    //   setShowTotalCost(false)
                    // }}
                    // onBlur={() => {
                    //   setShowTotalCost(true)
                    // }}
                  >
                    <Select
                      allowClear
                      options={existingLoanOptions}
                      onChange={(value) => {
                        if (value === '2') {
                          form.setFieldsValue({
                            existingLoanAmount: ''
                          })
                        }
                        setExistingLoan(value)
                      }}
                    />
                  </Form.Item>
                </Col>
                {/* {
                  existingLoan === '2' &&
                  <Col span={24} md={12}>
                    <div>
                    </div>
                  </Col>
                } */}
                {
                  existingLoan === '1' && (
                    <Col span={24} md={12}>
                      <Form.Item 
                        name="existingLoanAmount" 
                        label="Existing Loan Amount"
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                        validateTrigger={['onChange', 'onSubmit']}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (value < getFieldValue('initialLoanAmount')) {
                                return Promise.reject(new Error("Existing loan cannot be lower than initial loan."));
                              }
                              return Promise.resolve();
                            }
                          })
                        ]}
                      >
                        <InputNumber
                          prefix="$"
                          style={{ width: '100%' }}
                          max={10000000}
                          min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                      </Form.Item>
                    </Col>
                  )
                }
                {
                  existingLoan === '2' &&
                  <>
                    <Col span={24} md={12}>
                      <Form.Item 
                        name="purchaseDate" 
                        label="Purchase Date"
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                      >
                        <DatePicker 
                            className='closing-date' 
                            placeholder="MM/DD/YYYY" 
                            format="MM/DD/YYYY" 
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12} className='cost-to-date-item'>
                      <Form.Item
                        name="costToDate"
                        label="Cost to Date"
                        // tooltip={{
                        //   title: '(soft, horizontal, etc.)',
                        //   icon: <QuestionCircleFilled className="tips-icon" />,
                        // }}
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                      >
                        <InputNumber
                          prefix="$" 
                          style={{ width: '100%' }}
                          max={10000000}
                          min={0}
                          formatter={inputFormatter}
                          parser={inputParser}
                        />
                      </Form.Item>
                    </Col>
                  </>
                }
              {
                form.getFieldValue("rehabType") === '1' &&
                <Col span={24} md={12}>
                  <Form.Item
                    name="rehabBudget"
                    label="Rehab Budget"
                    validateTrigger={['onBlur']}
                    onBlur={() => {
                      setShowTotalCost(true)
                      setShowTotalLoanAmount(true)
                      showRatiosOnBlur()
                    }}
                    onChange={(value) => {
                      setShowTotalCost(false)
                      setShowTotalLoanAmount(false)
                    }}
                    onFocus={hideRatiosOnFocus}
                    rules={[
                      ({ getFieldValue, setFieldsValue }) => ({
                        validator(_, value) {
                          const asIsValue = getFieldValue('appraisedValue');
                          if (!value || !asIsValue || value < asIsValue * 0.3) {
                            return Promise.resolve();
                          } else {
                            setFieldsValue({
                              rehabType: '2'
                            })
                            setRehabType('2')
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
              }
              {
                form.getFieldValue("rehabType") === '2' &&
                <Col span={24} md={12}>
                  <Form.Item
                    name="rehabBudget"
                    label="Rehab Budget"
                    validateTrigger={['onBlur']}
                    onBlur={() => {
                      setShowTotalCost(true)
                      setShowTotalLoanAmount(true)
                      showRatiosOnBlur()
                    }}
                    onChange={(value) => {
                      setShowTotalCost(false)
                      setShowTotalLoanAmount(false)
                    }}
                    onFocus={hideRatiosOnFocus}
                    rules={[
                      ({ getFieldValue, setFieldsValue }) => ({
                        validator(_, value) {
                          const asIsValue = getFieldValue('appraisedValue');
                          if (!value || !asIsValue || value >= asIsValue * 0.3) {
                            return Promise.resolve();
                          } else {
                            setFieldsValue({
                              rehabType: '1'
                            })
                            setRehabType('1')
                            return Promise.resolve();
                          }
                        },
                      }),
                    ]}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
              }
              <Col span={24} md={12}>
                  <Form.Item name="totalCost" label="Total Cost">
                    <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                <Form.Item
                  name="appraisedValue"
                  label="As Is Value"
                  validateTrigger={['onBlur']}
                  rules={[
                    ({ getFieldValue, setFieldsValue }) => ({
                      validator(_, value) {
                        if (value*0.3 < getFieldValue("rehabBudget")) {
                          setFieldsValue({
                            rehabType: '2'
                          })
                        } else {
                          setFieldsValue({
                            rehabType: '1'
                          })
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}  
                  onBlur={() => {
                    setShowTotalCost(true)
                    showRatiosOnBlur()
                  }}
                  onFocus={() => {
                    setShowTotalCost(false)
                    hideRatiosOnFocus()
                  }}
                >
                  <InputNumber
                    prefix="$" 
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={12}>
                  <Form.Item 
                    name="projectedAfterRepair" 
                    label="After-Repair Value"
                    onBlur={() => {
                      showRatiosOnBlur()
                    }}
                    onFocus={() => {
                      hideRatiosOnFocus()
                    }}
                  >
                    <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={8}>
                <Form.Item 
                  name="initialLoanAmount" 
                  label="Initial Loan"
                  onChange={(value) => {
                    setShowTotalLoanAmount(false)
                  }}
                  onBlur={() => {
                    setShowTotalLoanAmount(true)
                    showRatiosOnBlur()
                  }}
                  onFocus={() => {
                    hideRatiosOnFocus()
                  }}
                  validateTrigger={['onBlur', 'onSubmit']}
                  rules={[
                    ({ getFieldValue, setFieldsValue }) => ({
                      validator(_, value) {
                        if (existingLoan === '1' && value > getFieldValue("existingLoanAmount")) {
                          return Promise.reject(new Error("Initial Loan cannot be greater than Existing Loan"));
                        } else if (existingLoan === '2' && value > getFieldValue("purchasePrice")) {
                          return Promise.reject(new Error("Initial Loan cannot be greater than Purchase Price"));
                        } else {
                          return Promise.resolve();
                        }
                      }
                    })
                  ]}
                >
                  <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={8}>
                  <Form.Item 
                    name="rehabLoanAmount" 
                    label="Rehab Loan"
                    validateTrigger={['onBlur', 'onSubmit']}
                    rules={[
                      ({ getFieldValue, setFieldsValue }) => ({
                        validator(_, value) {
                          if (value > getFieldValue("rehabBudget")) {
                            return Promise.reject(new Error("Rehab Loan cannot be greater than Rehab Budget"));
                          } else {
                            return Promise.resolve();
                          }
                        }
                      })
                    ]}
                  >
                    <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                    onFocus={() => {
                      setShowTotalLoanAmount(false)
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      setShowTotalLoanAmount(true)
                      showRatiosOnBlur()
                    }}
                    // disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={8}>
                <Form.Item 
                  name="totalLoanAmount" 
                  label="Total Requested Loan"
                >
                  <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={24}>
                <div className='display-result'>
                  <div className='display-result-item'>
                    <div className='label'>Current LTAIV</div>
                    <div>{showRatios ? currentLTAIV+"%" : '--'}</div>
                  </div>
                  <div className='display-result-item'>
                    <div className='label'>Current LTC</div>
                    <div>{showRatios ? currentLTC+"%" : '--'}</div>
                  </div>
                  <div className='display-result-item'>
                    <div className='label'>Current LTARV</div>
                    <div>{showRatios ? currentLTARV+"%" : '--'}</div>
                  </div>
                </div>
              </Col>
            </Row>
          }
          {
            active === '2' &&
              <Row gutter={24} style={{padding: '16px 50px 0 50px'}}>
                <Col span={24} md={12}>
                  <Form.Item
                    name="propertyType"
                    label="Property Type"
                    className='tooltip-item'
                    // tooltip={{
                    //   title: 'Property Type',
                    //   icon: <QuestionCircleFilled className="tips-icon" />,
                    // }}
                  >
                  <Select
                    allowClear
                    options={BridgePropertyTypeOptions}
                  />
                  </Form.Item>
                </Col>
                <Col span={24} md={12}>
                  <Form.Item
                    name="bridgeType"
                    label="Bridge Type"
                    className='tooltip-item'
                    // tooltip={{
                    //   title: 'Property Type',
                    //   icon: <QuestionCircleFilled className="tips-icon" />,
                    // }}
                  >
                  <Select
                    allowClear
                    options={BridgeTypeOptions}
                    onChange={(value) => {
                      setBridgeType(value)
                    }}
                  />
                  </Form.Item>
                </Col>
                <Col span={24} md={bridgeType === "5" ? 12 : 8}>
                  <Form.Item
                    name="purchasePrice"
                    label="Purchase Price"
                    onFocus={() => {
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      showRatiosOnBlur()
                    }}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
                {
                  bridgeType !== "5" &&
                  <Col span={24} md={8}>
                    <Form.Item name="purchaseDate" label="Purchase Date">
                      <DatePicker 
                          className='closing-date' 
                          placeholder="MM/DD/YYYY" 
                          format="MM/DD/YYYY" 
                      />
                    </Form.Item>
                  </Col>
                }
                {
                  bridgeType !== "5" &&
                  <Col span={24} md={8}>
                    <Form.Item 
                      name="existingLoanAmount" 
                      label="Existing Loan Amount"
                      onFocus={() => {
                        hideRatiosOnFocus()
                      }}
                      onBlur={() => {
                        showRatiosOnBlur()
                      }}
                    >
                      <InputNumber
                        prefix="$"
                        style={{ width: '100%' }}
                        max={10000000}
                        min={0}
                        formatter={inputFormatter}
                        parser={inputParser}
                      />
                    </Form.Item>
                  </Col>
                }
                <Col span={24} md={12}>
                  <Form.Item
                    name="appraisedValue"
                    label="As Is Value"
                    onFocus={() => {
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      showRatiosOnBlur()
                    }}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
                {
                  bridgeType !== "4" &&
                  <Col span={24} md={12}>
                    <Form.Item 
                      name="totalLoanAmount" 
                      label="Total Requested Loan"
                      validateTrigger={['onBlur']}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const existingLoanAmount = getFieldValue('existingLoanAmount');
                            if (!value || !existingLoanAmount || value <= existingLoanAmount) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error("You can't refinance more than the existing loan amount"));
                          },
                        }),
                      ]}
                      onFocus={() => {
                        hideRatiosOnFocus()
                      }}
                      onBlur={() => {
                        showRatiosOnBlur()
                      }}
                    >
                      <InputNumber
                        prefix="$"
                        style={{ width: '100%' }}
                        max={10000000}
                        min={0}
                        formatter={inputFormatter}
                        parser={inputParser}
                      />
                    </Form.Item>
                  </Col>
                }
                {
                  bridgeType === "4" &&
                  <Col span={24} md={12}>
                    <Form.Item 
                      name="cashoutAmount" 
                      label="Cash Out Amount"
                      onFocus={() => {
                        hideRatiosOnFocus()
                      }}
                      onBlur={() => {
                        showRatiosOnBlur()
                      }}
                    >
                      <InputNumber
                        prefix="$"
                        style={{ width: '100%' }}
                        max={10000000}
                        min={0}
                        formatter={inputFormatter}
                        parser={inputParser}
                      />
                    </Form.Item>
                  </Col>
                }
                <Col span={24} md={24}>
                  <div className='display-result'>
                    <div className='display-result-item'>
                      <div className='label'>Current LTAIV</div>
                      <div>{showRatios ? currentLTAIV+"%" : '--'}</div>
                    </div>
                    <div className='display-result-item'>
                      <div className='label'>Current LTC</div>
                      <div>{showRatios ? currentLTC+"%" : '--'}</div>
                    </div>
                    <div className='display-result-item'>
                      <div className='label'>Current LTARV</div>
                      <div>{showRatios ? currentLTARV+"%" : '--'}</div>
                    </div>
                  </div>
                </Col>
              </Row>
          }
          {
            active === '3' &&
              <Row gutter={24} style={{padding: '16px 50px 0 50px'}}>
                <Col span={24} md={12}>
                  <Form.Item
                    name="propertyType"
                    label="Property Type"
                    className='tooltip-item'
                    // tooltip={{
                    //   title: 'Property Type',
                    //   icon: <QuestionCircleFilled className="tips-icon" />,
                    // }}
                  >
                  <Select
                    allowClear
                    options={PropertyTypeOptions}
                  />
                  </Form.Item>
                </Col>
                <Col span={24} md={12}>
                  <Form.Item
                    name="landEntitlement"
                    label="Permit Ready"
                    validateTrigger={['onBlur', 'onSubmit']}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (value === 'permitnotready') {
                            setShowPermitAlert(true)
                          } else {
                            setShowPermitAlert(false)
                          }
                          return Promise.resolve();
                        }
                      })
                    ]}
                  >
                  <Select
                    allowClear
                    options={LandEntitlementOptions}
                  />
                  </Form.Item>
                </Col>
                {showPermitAlert && active === "3" && (
                  <div className='alert-row'>{`You must have a land permit ready to be eligible for this loan.`}</div>
                )}
                <Col span={24} md={existingLoan === '2' ? 12 : 8}>
                  <Form.Item
                    name="purchasePrice"
                    label="Purchase Price"
                    onFocus={() => {
                      setShowTotalCost(false)
                      showRatiosOnBlur()
                    }}
                    onBlur={() => {
                      setShowTotalCost(true)
                      showRatiosOnBlur()
                    }}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} md={existingLoan === '2' ? 12 : 8}>
                  <Form.Item 
                    name="existLoan" 
                    label="Existing Loan"
                    // onFocus={() => {
                    //   setShowTotalCost(false)
                    // }}
                    // onBlur={() => {
                    //   setShowTotalCost(true)
                    // }}
                  >
                    <Select
                      allowClear
                      options={existingLoanOptions}
                      onChange={(value) => {
                        if (value === '2') {
                          form.setFieldsValue({
                            existingLoanAmount: ''
                          })
                        }
                        setExistingLoan(value)
                      }}
                    />
                  </Form.Item>
                </Col>
                {
                  existingLoan === '1' && (
                    <Col span={24} md={8}>
                      <Form.Item 
                        name="existingLoanAmount" 
                        label="Existing Loan Amount"
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                        validateTrigger={['onChange', 'onSubmit']}
                        rules={[
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (value < getFieldValue('initialLoanAmount')) {
                                return Promise.reject(new Error("Existing loan cannot be lower than initial loan."));
                              }
                              return Promise.resolve();
                            }
                          })
                        ]}
                      >
                        <InputNumber
                          prefix="$"
                          style={{ width: '100%' }}
                          max={10000000}
                          min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                      </Form.Item>
                    </Col>
                  )
                }
                {
                  existingLoan === '2' &&
                  <>
                    <Col span={24} md={12}>
                      <Form.Item 
                        name="purchaseDate" 
                        label="Purchase Date"
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                      >
                        <DatePicker 
                            className='closing-date' 
                            placeholder="MM/DD/YYYY" 
                            format="MM/DD/YYYY" 
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                      <Form.Item
                        name="costToDate"
                        label="Cost to Date"
                        tooltip={{
                          title: '(soft, horizontal, etc.)',
                          icon: <QuestionCircleFilled className="tips-icon" />,
                        }}
                        onFocus={() => {
                          setShowTotalCost(false)
                        }}
                        onBlur={() => {
                          setShowTotalCost(true)
                        }}
                      >
                        <InputNumber
                          prefix="$" 
                          style={{ width: '100%' }}
                          max={10000000}
                          min={0}
                          formatter={inputFormatter}
                          parser={inputParser}
                        />
                      </Form.Item>
                    </Col>
                  </>
                }
                <Col span={24} md={8}>
                  <Form.Item 
                    name="constructionBudget" 
                    label="Construction Budget"
                    onFocus={() => {
                      setShowTotalCost(false)
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      setShowTotalCost(true)
                      showRatiosOnBlur()
                    }}
                  >
                    <InputNumber
                      prefix="$"
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} md={8}>
                    <Form.Item 
                      name="interestReserves" 
                      label="Interest Reserves"
                      onFocus={() => {
                        setShowTotalCost(false)
                        setShowTotalLoanAmount(false)
                      }}
                      onBlur={() => {
                        setShowTotalCost(true)
                        setShowTotalLoanAmount(true)
                      }}
                    >
                        <InputNumber
                          style={{ width: '100%' }}
                          precision={0}
                          min={0}
                          suffix="months"
                    />
                  </Form.Item>
                </Col>
                <Col span={24} md={8}>
                  <Form.Item name="totalCost" label="Total Cost">
                    <InputNumber
                      prefix="$"
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} md={12}>
                  <Form.Item
                    name="appraisedValue"
                    label="As Is Value"
                    onFocus={() => {
                      setShowTotalCost(false)
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      setShowTotalCost(true)
                      showRatiosOnBlur()
                    }}
                  >
                    <InputNumber
                      prefix="$" 
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
                <Col span={24} md={12}>
                    <Form.Item 
                    name="projectedAfterRepair" 
                    label="After-Repair Value"
                    onFocus={() => {
                      hideRatiosOnFocus()
                    }}
                    onBlur={() => {
                      showRatiosOnBlur()
                    }}
                    >
                      <InputNumber
                      prefix="$"
                      style={{ width: '100%' }}
                      max={10000000}
                      min={0}
                      formatter={inputFormatter}
                      parser={inputParser}
                    />
                  </Form.Item>
                </Col>
              <Col span={24} md={8}>
                <Form.Item 
                  name="initialLoanAmount" 
                  label="Initial Loan"
                  onFocus={() => {
                    setShowTotalCost(false)
                    setShowTotalLoanAmount(false)
                    hideRatiosOnFocus()
                  }}
                  onBlur={() => {
                    setShowTotalCost(true)
                    setShowTotalLoanAmount(true)
                    showRatiosOnBlur()
                  }}
                  validateTrigger={['onChange', 'onSubmit']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (existingLoan === '1' &&value > getFieldValue('existingLoanAmount')) {
                          return Promise.reject(new Error("Initial loan cannot be greater than existing loan."));
                        }
                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                  <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={8}>
                <Form.Item name="constructionBudget" label="Construction Loan">
                  <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={8}>
                <Form.Item name="totalLoanAmount" label="Total Requested Loan">
                  <InputNumber
                    prefix="$"
                    style={{ width: '100%' }}
                    max={10000000}
                    min={0}
                    formatter={inputFormatter}
                    parser={inputParser}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={24} md={24}>
                <div className='display-result'>
                  <div className='display-result-item'>
                    <div className='label'>Current LTAIV</div>
                    <div>{showRatios ? currentLTAIV+"%" : '--'}</div>
                  </div>
                  <div className='display-result-item'>
                    <div className='label'>Current LTC</div>
                    <div>{showRatios ? currentLTC+"%" : '--'}</div>
                  </div>
                  <div className='display-result-item'>
                    <div className='label'>Current LTARV</div>
                    <div>{showRatios ? currentLTARV+"%" : '--'}</div>
                  </div>
                </div>
              </Col>
            </Row>
          }
          <Row gutter={80}>
            <Col span={24} md={16} >
              <Button className='calc-btn' htmlType="submit" block>
                Calculate
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

LoanRateCalculator = connect(mapStateToProps, mapDispatchToProps)(LoanRateCalculator);
